import PropTypes from 'prop-types';
import styles from './FJModelList.module.less';
import FJVerticalScroller from '../../FJScroller/FJVerticalScroller';

const FJModelList = ({ children }) => {
    return <FJVerticalScroller className={styles.scroller}>{children}</FJVerticalScroller>;
};

FJModelList.propTypes = {
    children: PropTypes.node,
};

export default FJModelList;
